var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.offers.length)?_c('div',{staticClass:"flex gap-1"},_vm._l((_vm.offers.slice(0, 1)),function(offer,index){return _c('div',{key:index,staticClass:"mb-1 px-4 flex items-center w-fit-content rounded",class:offer.offerColor && offer.offerColor.value
        ? `offer--${offer.offerColor.value}`
        : 'offer--purplePrimary'},[_c('span',[_vm._v(_vm._s(offer.tag))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }